// extracted by mini-css-extract-plugin
export default {"container":"orderDetails_container__jMCn9","title":"orderDetails_title__OURA2","type":"orderDetails_type__-xzrS"};